import $ from 'jquery';

$(() => {
  const drawer = $('#mobile-menu');

  $("[data-drawer-show='mobile-menu']").on('click', function () {
    drawer.removeClass('-translate-x-full');
    drawer.removeAttr('inert');
  });

  $("[data-drawer-hide='mobile-menu']").on('click', function () {
    drawer.addClass('-translate-x-full');
    drawer.attr('inert', '');
  });

  $('#mobile-menu .toggle-submenu').on('click', function () {
    const $btn = $(this);
    const $submenu = $btn.closest('div').next('ul');
    $('#mobile-menu .toggle-submenu')
      .not($btn)
      .attr('aria-expanded', false)
      .find('svg')
      .removeClass('rotate-180');
    $('#mobile-menu nav ul').not($submenu).slideUp(200);
    $submenu.slideToggle(200);
    $btn.find('svg').toggleClass('rotate-180');
    $btn.attr('aria-expanded', $submenu.is(':visible'));
  });
});
